import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQItem from '../components/FAQItem';
import { FiFlag, FiHeart, FiLink, FiMessageCircle, FiSearch, FiShare2, FiUser, FiUsers } from 'react-icons/fi';

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-slate-50">
        <div className="absolute inset-x-0 top-0 h-[360px] bg-[radial-gradient(circle_at_top_left,_rgba(99,102,241,0.16),_transparent_42%),radial-gradient(circle_at_top_right,_rgba(14,165,233,0.12),_transparent_38%)]" />
        <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-indigo-200 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-indigo-700 shadow-sm">
            FAQS
          </div>
          <h1 className="mt-6 max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-5xl">
            Frequently asked questions
          </h1>
        </div>
      </section>

      <main className="bg-white px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
            <FAQItem title="Why do I have a learnwebcare.com charge on my bank statement?" icon={<FiHeart />}>
              If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of learnwebcare.com, but a client of a site that has delegated the management of its customer service.
            </FAQItem>

            <FAQItem title="What are the services offered by learnwebcare.com?" icon={<FiFlag />}>
              learnwebcare.com offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.
            </FAQItem>

            <FAQItem title="What kind of subscription do you need for after-sales service?" icon={<FiSearch />}>
              learnwebcare.com provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.
            </FAQItem>

            <FAQItem title="I do not remember signing up to a learnwebcare.com subscription." icon={<FiShare2 />}>
              You have not signed up to a learnwebcare.com subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.
            </FAQItem>

            <FAQItem title="How to find the offer to which I subscribed?" icon={<FiLink />}>
              Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.
            </FAQItem>

            <FAQItem title="I forgot the email address used when subscribing. What can I do?" icon={<FiUser />}>
              If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.
            </FAQItem>

            <FAQItem title="Who can I contact if I have a question?" icon={<FiMessageCircle />}>
              Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.
            </FAQItem>

            <FAQItem title="How can I cancel my subscription?" icon={<FiUsers />}>
              Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.
            </FAQItem>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}